<template>
    <div>
        <ProfileBlock
            title="Current reservation"
            :override-background="overrideBackground"
        >
            <div class="px-4 py-5 sm:p-0">
                <dl class="sm:divide-y sm:divide-gray-200">
                    <div
                        class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                    >
                        <dt class="text-sm font-medium text-gray-500">
                            Booking reference
                        </dt>
                        <dd
                            class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                        >
                            {{ reservation.booking_reference }}
                        </dd>
                    </div>
                    <div
                        class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                    >
                        <dt class="text-sm font-medium text-gray-500">
                            Stay
                        </dt>
                        <dd
                            class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                        >
                            {{ reservation.nights }} nights,
                            <span class="mr-3"
                                >from {{ format(reservation.start) }} to
                                {{ format(reservation.end) }}</span
                            >
                        </dd>
                    </div>
                    <div
                        class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                    >
                        <dt class="text-sm font-medium text-gray-500">
                            Guests
                        </dt>
                        <dd
                            class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                        >
                            {{ reservation.number_of_adults }}
                            {{
                                reservation.number_of_adults > 1
                                    ? "adults"
                                    : "adult"
                            }}
                            <span
                                v-if="reservation.number_of_children"
                                class="ml-3"
                            >
                                {{ reservation.number_of_children }}
                                {{
                                    reservation.number_of_children > 1
                                        ? "children"
                                        : "child"
                                }}
                            </span>
                        </dd>
                    </div>

                    <div
                        v-if="reservation.spaces.length"
                        class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                    >
                        <dt class="text-sm font-medium text-gray-500">
                            Room
                        </dt>
                        <dd
                            class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                        >
                            <div
                                v-for="(space, key) in reservation.spaces"
                                :key="key"
                            >
                                {{ space.name }}
                                <span v-if="space.floor" class="ml-3"
                                    >Floor {{ space.floor }}</span
                                >
                                <span v-if="space.number" class="ml-3"
                                    >Nr. {{ space.number }}</span
                                >
                            </div>
                        </dd>
                    </div>
                    <!--
                     Should probably be hidden to the guest
                     <div
                        v-if="reservation.rate_plans.length"
                        class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                    >
                        <dt class="text-sm font-medium text-gray-500">
                            Rates
                        </dt>
                        <dd
                            class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                        >
                            <div
                                v-for="(rate, key) in reservation.rate_plans"
                                :key="key"
                            >
                                <div>{{ rate.name }}</div>
                            </div>
                        </dd>
                    </div>-->
                    <div
                        class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
                    >
                        <dt class="text-sm font-medium text-gray-500">
                            Balance
                        </dt>
                        <dd
                            class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"
                        >
                            Total:
                            <b class="mr-3"
                                >{{ reservation.currency
                                }}{{ reservation.total_gross_amount }}</b
                            >
                            Open:
                            <b
                                >{{ reservation.currency
                                }}{{ reservation.balance }}</b
                            >
                        </dd>
                    </div>
                </dl>
            </div>
            <div class="text-center" v-if="!reservation">
                <span>{{ $t("components.current_reservation.empty") }}</span>
            </div>
            <template v-slot:block-link>
                <router-link
                    tag="div"
                    :to="{ name: 'ViewReservations' }"
                    v-dr-permission="'drg.app.profile.edit'"
                >
                    {{ $t("components.current_reservation.view_button") }}
                </router-link>
            </template>
        </ProfileBlock>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "CurrentReservation",
    components: { ProfileBlock },
    props: ["overrideBackground"],
    methods: {
        format(datetime) {
            return new Date(datetime).toLocaleDateString();
        },
        ...mapActions({ fetch: "profile/reservations/fetchCurrentReservation" })
    },
    computed: mapGetters({
        reservation: "profile/reservations/current_reservation"
    }),
    mounted() {
        this.fetch();
    }
};
</script>

<style scoped></style>
